import { ButtonComponent } from "../components/button";
import { BigCardComponent } from "../components/cards/big-card";
import { CardComponent } from "../components/cards/card";
import { CarouselComponent } from "../components/cards/carousel";
import { CtaCardComponent } from "../components/cards/cta-card";
import { ImageCardComponent } from "../components/cards/image-card";
import { PersonCardComponent } from "../components/cards/person-card";
import { TestimonyCarouselComponent } from "../components/cards/testimony-carousel";
import { WeeztixCardComponent } from "../components/cards/weeztix-card";
import { KidsGroupCollectionComponent } from "../components/church/kids-group-collection";
import { FaqComponent } from "../components/content/faq";
import { FaqItemComponent } from "../components/content/faq-item";
import { RichText } from "../components/content/rich-text";
import { ScreenTitleComponent } from "../components/content/screen-title";
import { ScriptureComponent } from "../components/content/scripture";
import { StatementComponent } from "../components/content/statement";
import { CookieDeclarationComponent } from "../components/cookie-declaration";
import { EventHighlightComponent } from "../components/event-highlight";
import { EventHeroComponent } from "../components/events/event-hero";
import { EventListComponent } from "../components/events/event-list";
import { FilloutFormComponent } from "../components/fillout-form";
import { BlokHeroComponent } from "../components/heroes/blok-hero";
import { ImageHeroComponent } from "../components/heroes/image-hero";
import { GridComponent } from "../components/layouts/grid";
import { SectionComponent } from "../components/layouts/section";
import { ImageComponent } from "../components/media/image";
import { MediaReleaseComponent } from "../components/media/media-release";
import { SpotifyEmbedComponent } from "../components/media/spotify-emebd";
import { YoutubeEmbedComponent } from "../components/media/youtube-embed";
import Page from "../components/page";
import { ScrollingTextComponent } from "../components/scrolling-text";
import { SermonListComponent } from "../components/sermon-list";
import { NextServiceBannerComponent } from "../components/church/next-service-banner";
import { ChurchSchemaComponent, OrganizationSchemaComponent } from "../components/schemas";

export const componentsMap = {
  page: Page,
  imageHero: ImageHeroComponent,
  screenTitle: ScreenTitleComponent,
  button: ButtonComponent,
  section: SectionComponent,
  grid: GridComponent,
  imageCard: ImageCardComponent,
  card: CardComponent,
  richText: RichText,
  scripture: ScriptureComponent,
  statement: StatementComponent,
  image: ImageComponent,
  testimonyCarousel: TestimonyCarouselComponent,
  scrollingText: ScrollingTextComponent,
  filloutForm: FilloutFormComponent,
  blokHero: BlokHeroComponent,
  carousel: CarouselComponent,
  bigCard: BigCardComponent,
  faqItem: FaqItemComponent,
  faq: FaqComponent,
  sermonList: SermonListComponent,
  eventHighlight: EventHighlightComponent,
  eventHero: EventHeroComponent,
  eventList: EventListComponent,
  kidsGroupCollection: KidsGroupCollectionComponent,
  ctaCard: CtaCardComponent,
  cookieDeclaration: CookieDeclarationComponent,
  spotifyEmbed: SpotifyEmbedComponent,
  youtubeEmbed: YoutubeEmbedComponent,
  weeztixEvent: WeeztixCardComponent,
  mediaRelease: MediaReleaseComponent,
  personCard: PersonCardComponent,
  nextServiceBanner: NextServiceBannerComponent,
  organizationSchema: OrganizationSchemaComponent,
  churchSchema: ChurchSchemaComponent,
} as const;
